/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RoiDemoRouteImport } from './routes/roi-demo'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as PrivacyRouteRouteImport } from './routes/_privacy/route'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersOrganizationManagementRouteImport } from './routes/_users/OrganizationManagement'
import { Route as SigninSigninRouteImport } from './routes/_signin/signin'
import { Route as PrivacyTermsOfUseRouteImport } from './routes/_privacy/terms-of-use'
import { Route as PrivacyPrivacyPolicyRouteImport } from './routes/_privacy/privacy-policy'
import { Route as OnboardingRetrospectivesRouteImport } from './routes/_onboarding/retrospectives'
import { Route as OnboardingProjectRouteImport } from './routes/_onboarding/project'
import { Route as OnboardingOnboardingRouteImport } from './routes/_onboarding/onboarding'
import { Route as OnboardingLeadershipRouteImport } from './routes/_onboarding/leadership'
import { Route as OnboardingGetStartedRouteImport } from './routes/_onboarding/get-started'
import { Route as OnboardingEffectivenessRouteImport } from './routes/_onboarding/effectiveness'
import { Route as OnboardingCommandCenterRouteImport } from './routes/_onboarding/command-center'
import { Route as OnboardingBreaksRouteImport } from './routes/_onboarding/breaks'
import { Route as DashboardGoalsRouteImport } from './routes/_dashboard/goals'
import { Route as DashboardDealIntelligenceRouteImport } from './routes/_dashboard/deal-intelligence'
import { Route as AdminIntegrationsRouteImport } from './routes/_admin/integrations'
import { Route as DashboardInteractionsRouteRouteImport } from './routes/_dashboard/interactions/route'
import { Route as DashboardGapReviewRouteRouteImport } from './routes/_dashboard/gap-review/route'
import { Route as DashboardOneOnOneIndexRouteImport } from './routes/_dashboard/one-on-one/index'
import { Route as DashboardInteractionsIndexRouteImport } from './routes/_dashboard/interactions/index'
import { Route as DashboardGapReviewIndexRouteImport } from './routes/_dashboard/gap-review/index'
import { Route as RoiDemoProjectsProjectIdRouteImport } from './routes/roi-demo.projects.$projectId'
import { Route as DashboardInteractionsPraiseWizardRouteImport } from './routes/_dashboard/interactions/PraiseWizard'
import { Route as DashboardInteractionsFeedbackWizardRouteImport } from './routes/_dashboard/interactions/FeedbackWizard'
import { Route as DashboardInteractionsDebriefWizardRouteImport } from './routes/_dashboard/interactions/DebriefWizard'
import { Route as DashboardGapReviewFinalRouteImport } from './routes/_dashboard/gap-review/final'
import { Route as DashboardAdminEmployeeHierarchyRouteImport } from './routes/_dashboard/admin/employee-hierarchy'
import { Route as DashboardOneOnOneIdSummaryRouteImport } from './routes/_dashboard/one-on-one/$id.summary'
import { Route as DashboardOneOnOneIdGoalsReviewRouteImport } from './routes/_dashboard/one-on-one/$id.goals-review'
import { Route as DashboardOneOnOneIdCompletedRouteImport } from './routes/_dashboard/one-on-one/$id.completed'
import { Route as DashboardInteractionsPraiseIdRouteImport } from './routes/_dashboard/interactions/praise.$id'
import { Route as DashboardInteractionsFeedbackIdRouteImport } from './routes/_dashboard/interactions/feedback.$id'
import { Route as DashboardInteractionsDebriefIdRouteImport } from './routes/_dashboard/interactions/debrief.$id'
import { Route as DashboardInteractionsDebriefV2IdRouteImport } from './routes/_dashboard/interactions/debrief-v2.$id'
import { Route as DashboardGapReviewRunExecutionIdRouteImport } from './routes/_dashboard/gap-review/run.$executionId'
import { Route as DashboardGapReviewPreviewDraftIdRouteImport } from './routes/_dashboard/gap-review/preview.$draftId'
import { Route as DashboardDealIntelligenceProjectProjectIdRouteImport } from './routes/_dashboard/deal-intelligence_.project.$projectId'
import { Route as DashboardDealIntelligenceGapGapIdRouteImport } from './routes/_dashboard/deal-intelligence_.gap.$gapId'
import { Route as DashboardInteractionsDebriefV2IdMatchPointsRouteImport } from './routes/_dashboard/interactions/debrief-v2.$id.match-points'
import { Route as DashboardInteractionsDebriefV2IdLessonsRouteImport } from './routes/_dashboard/interactions/debrief-v2.$id.lessons'
import { Route as DashboardInteractionsDebriefV2IdGatherRouteImport } from './routes/_dashboard/interactions/debrief-v2.$id.gather'
import { Route as DashboardInteractionsDebriefV2IdDescribeRouteImport } from './routes/_dashboard/interactions/debrief-v2.$id.describe'
import { Route as DashboardInteractionsDebriefV2IdDeepDiveRouteImport } from './routes/_dashboard/interactions/debrief-v2.$id.deep-dive'
import { Route as DashboardDealIntelligenceProjectProjectIdGapGapIdRouteImport } from './routes/_dashboard/deal-intelligence_.project.$projectId_.gap.$gapId'

const RoiDemoRoute = RoiDemoRouteImport.update({
  id: '/roi-demo',
  path: '/roi-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRouteRoute = PrivacyRouteRouteImport.update({
  id: '/_privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersOrganizationManagementRoute =
  UsersOrganizationManagementRouteImport.update({
    id: '/_users/OrganizationManagement',
    path: '/OrganizationManagement',
    getParentRoute: () => rootRouteImport,
  } as any)
const SigninSigninRoute = SigninSigninRouteImport.update({
  id: '/_signin/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyTermsOfUseRoute = PrivacyTermsOfUseRouteImport.update({
  id: '/terms-of-use',
  path: '/terms-of-use',
  getParentRoute: () => PrivacyRouteRoute,
} as any)
const PrivacyPrivacyPolicyRoute = PrivacyPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => PrivacyRouteRoute,
} as any)
const OnboardingRetrospectivesRoute =
  OnboardingRetrospectivesRouteImport.update({
    id: '/_onboarding/retrospectives',
    path: '/retrospectives',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingProjectRoute = OnboardingProjectRouteImport.update({
  id: '/_onboarding/project',
  path: '/project',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingOnboardingRoute = OnboardingOnboardingRouteImport.update({
  id: '/_onboarding/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingLeadershipRoute = OnboardingLeadershipRouteImport.update({
  id: '/_onboarding/leadership',
  path: '/leadership',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingGetStartedRoute = OnboardingGetStartedRouteImport.update({
  id: '/_onboarding/get-started',
  path: '/get-started',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingEffectivenessRoute = OnboardingEffectivenessRouteImport.update({
  id: '/_onboarding/effectiveness',
  path: '/effectiveness',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingCommandCenterRoute = OnboardingCommandCenterRouteImport.update({
  id: '/_onboarding/command-center',
  path: '/command-center',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingBreaksRoute = OnboardingBreaksRouteImport.update({
  id: '/_onboarding/breaks',
  path: '/breaks',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardGoalsRoute = DashboardGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDealIntelligenceRoute =
  DashboardDealIntelligenceRouteImport.update({
    id: '/deal-intelligence',
    path: '/deal-intelligence',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const AdminIntegrationsRoute = AdminIntegrationsRouteImport.update({
  id: '/_admin/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardInteractionsRouteRoute =
  DashboardInteractionsRouteRouteImport.update({
    id: '/interactions',
    path: '/interactions',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardGapReviewRouteRoute = DashboardGapReviewRouteRouteImport.update({
  id: '/gap-review',
  path: '/gap-review',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOneOnOneIndexRoute = DashboardOneOnOneIndexRouteImport.update({
  id: '/one-on-one/',
  path: '/one-on-one/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardInteractionsIndexRoute =
  DashboardInteractionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardInteractionsRouteRoute,
  } as any)
const DashboardGapReviewIndexRoute = DashboardGapReviewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardGapReviewRouteRoute,
} as any)
const RoiDemoProjectsProjectIdRoute =
  RoiDemoProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => RoiDemoRoute,
  } as any)
const DashboardInteractionsPraiseWizardRoute =
  DashboardInteractionsPraiseWizardRouteImport.update({
    id: '/PraiseWizard',
    path: '/PraiseWizard',
    getParentRoute: () => DashboardInteractionsRouteRoute,
  } as any)
const DashboardInteractionsFeedbackWizardRoute =
  DashboardInteractionsFeedbackWizardRouteImport.update({
    id: '/FeedbackWizard',
    path: '/FeedbackWizard',
    getParentRoute: () => DashboardInteractionsRouteRoute,
  } as any)
const DashboardInteractionsDebriefWizardRoute =
  DashboardInteractionsDebriefWizardRouteImport.update({
    id: '/DebriefWizard',
    path: '/DebriefWizard',
    getParentRoute: () => DashboardInteractionsRouteRoute,
  } as any)
const DashboardGapReviewFinalRoute = DashboardGapReviewFinalRouteImport.update({
  id: '/final',
  path: '/final',
  getParentRoute: () => DashboardGapReviewRouteRoute,
} as any)
const DashboardAdminEmployeeHierarchyRoute =
  DashboardAdminEmployeeHierarchyRouteImport.update({
    id: '/admin/employee-hierarchy',
    path: '/admin/employee-hierarchy',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOneOnOneIdSummaryRoute =
  DashboardOneOnOneIdSummaryRouteImport.update({
    id: '/one-on-one/$id/summary',
    path: '/one-on-one/$id/summary',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOneOnOneIdGoalsReviewRoute =
  DashboardOneOnOneIdGoalsReviewRouteImport.update({
    id: '/one-on-one/$id/goals-review',
    path: '/one-on-one/$id/goals-review',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOneOnOneIdCompletedRoute =
  DashboardOneOnOneIdCompletedRouteImport.update({
    id: '/one-on-one/$id/completed',
    path: '/one-on-one/$id/completed',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardInteractionsPraiseIdRoute =
  DashboardInteractionsPraiseIdRouteImport.update({
    id: '/praise/$id',
    path: '/praise/$id',
    getParentRoute: () => DashboardInteractionsRouteRoute,
  } as any)
const DashboardInteractionsFeedbackIdRoute =
  DashboardInteractionsFeedbackIdRouteImport.update({
    id: '/feedback/$id',
    path: '/feedback/$id',
    getParentRoute: () => DashboardInteractionsRouteRoute,
  } as any)
const DashboardInteractionsDebriefIdRoute =
  DashboardInteractionsDebriefIdRouteImport.update({
    id: '/debrief/$id',
    path: '/debrief/$id',
    getParentRoute: () => DashboardInteractionsRouteRoute,
  } as any)
const DashboardInteractionsDebriefV2IdRoute =
  DashboardInteractionsDebriefV2IdRouteImport.update({
    id: '/debrief-v2/$id',
    path: '/debrief-v2/$id',
    getParentRoute: () => DashboardInteractionsRouteRoute,
  } as any)
const DashboardGapReviewRunExecutionIdRoute =
  DashboardGapReviewRunExecutionIdRouteImport.update({
    id: '/run/$executionId',
    path: '/run/$executionId',
    getParentRoute: () => DashboardGapReviewRouteRoute,
  } as any)
const DashboardGapReviewPreviewDraftIdRoute =
  DashboardGapReviewPreviewDraftIdRouteImport.update({
    id: '/preview/$draftId',
    path: '/preview/$draftId',
    getParentRoute: () => DashboardGapReviewRouteRoute,
  } as any)
const DashboardDealIntelligenceProjectProjectIdRoute =
  DashboardDealIntelligenceProjectProjectIdRouteImport.update({
    id: '/deal-intelligence_/project/$projectId',
    path: '/deal-intelligence/project/$projectId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardDealIntelligenceGapGapIdRoute =
  DashboardDealIntelligenceGapGapIdRouteImport.update({
    id: '/deal-intelligence_/gap/$gapId',
    path: '/deal-intelligence/gap/$gapId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardInteractionsDebriefV2IdMatchPointsRoute =
  DashboardInteractionsDebriefV2IdMatchPointsRouteImport.update({
    id: '/match-points',
    path: '/match-points',
    getParentRoute: () => DashboardInteractionsDebriefV2IdRoute,
  } as any)
const DashboardInteractionsDebriefV2IdLessonsRoute =
  DashboardInteractionsDebriefV2IdLessonsRouteImport.update({
    id: '/lessons',
    path: '/lessons',
    getParentRoute: () => DashboardInteractionsDebriefV2IdRoute,
  } as any)
const DashboardInteractionsDebriefV2IdGatherRoute =
  DashboardInteractionsDebriefV2IdGatherRouteImport.update({
    id: '/gather',
    path: '/gather',
    getParentRoute: () => DashboardInteractionsDebriefV2IdRoute,
  } as any)
const DashboardInteractionsDebriefV2IdDescribeRoute =
  DashboardInteractionsDebriefV2IdDescribeRouteImport.update({
    id: '/describe',
    path: '/describe',
    getParentRoute: () => DashboardInteractionsDebriefV2IdRoute,
  } as any)
const DashboardInteractionsDebriefV2IdDeepDiveRoute =
  DashboardInteractionsDebriefV2IdDeepDiveRouteImport.update({
    id: '/deep-dive',
    path: '/deep-dive',
    getParentRoute: () => DashboardInteractionsDebriefV2IdRoute,
  } as any)
const DashboardDealIntelligenceProjectProjectIdGapGapIdRoute =
  DashboardDealIntelligenceProjectProjectIdGapGapIdRouteImport.update({
    id: '/deal-intelligence_/project/$projectId_/gap/$gapId',
    path: '/deal-intelligence/project/$projectId/gap/$gapId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/knowledge': typeof KnowledgeRoute
  '/roi-demo': typeof RoiDemoRouteWithChildren
  '/gap-review': typeof DashboardGapReviewRouteRouteWithChildren
  '/interactions': typeof DashboardInteractionsRouteRouteWithChildren
  '/integrations': typeof AdminIntegrationsRoute
  '/deal-intelligence': typeof DashboardDealIntelligenceRoute
  '/goals': typeof DashboardGoalsRoute
  '/breaks': typeof OnboardingBreaksRoute
  '/command-center': typeof OnboardingCommandCenterRoute
  '/effectiveness': typeof OnboardingEffectivenessRoute
  '/get-started': typeof OnboardingGetStartedRoute
  '/leadership': typeof OnboardingLeadershipRoute
  '/onboarding': typeof OnboardingOnboardingRoute
  '/project': typeof OnboardingProjectRoute
  '/retrospectives': typeof OnboardingRetrospectivesRoute
  '/privacy-policy': typeof PrivacyPrivacyPolicyRoute
  '/terms-of-use': typeof PrivacyTermsOfUseRoute
  '/signin': typeof SigninSigninRoute
  '/OrganizationManagement': typeof UsersOrganizationManagementRoute
  '/admin/employee-hierarchy': typeof DashboardAdminEmployeeHierarchyRoute
  '/gap-review/final': typeof DashboardGapReviewFinalRoute
  '/interactions/DebriefWizard': typeof DashboardInteractionsDebriefWizardRoute
  '/interactions/FeedbackWizard': typeof DashboardInteractionsFeedbackWizardRoute
  '/interactions/PraiseWizard': typeof DashboardInteractionsPraiseWizardRoute
  '/roi-demo/projects/$projectId': typeof RoiDemoProjectsProjectIdRoute
  '/gap-review/': typeof DashboardGapReviewIndexRoute
  '/interactions/': typeof DashboardInteractionsIndexRoute
  '/one-on-one': typeof DashboardOneOnOneIndexRoute
  '/deal-intelligence/gap/$gapId': typeof DashboardDealIntelligenceGapGapIdRoute
  '/deal-intelligence/project/$projectId': typeof DashboardDealIntelligenceProjectProjectIdRoute
  '/gap-review/preview/$draftId': typeof DashboardGapReviewPreviewDraftIdRoute
  '/gap-review/run/$executionId': typeof DashboardGapReviewRunExecutionIdRoute
  '/interactions/debrief-v2/$id': typeof DashboardInteractionsDebriefV2IdRouteWithChildren
  '/interactions/debrief/$id': typeof DashboardInteractionsDebriefIdRoute
  '/interactions/feedback/$id': typeof DashboardInteractionsFeedbackIdRoute
  '/interactions/praise/$id': typeof DashboardInteractionsPraiseIdRoute
  '/one-on-one/$id/completed': typeof DashboardOneOnOneIdCompletedRoute
  '/one-on-one/$id/goals-review': typeof DashboardOneOnOneIdGoalsReviewRoute
  '/one-on-one/$id/summary': typeof DashboardOneOnOneIdSummaryRoute
  '/interactions/debrief-v2/$id/deep-dive': typeof DashboardInteractionsDebriefV2IdDeepDiveRoute
  '/interactions/debrief-v2/$id/describe': typeof DashboardInteractionsDebriefV2IdDescribeRoute
  '/interactions/debrief-v2/$id/gather': typeof DashboardInteractionsDebriefV2IdGatherRoute
  '/interactions/debrief-v2/$id/lessons': typeof DashboardInteractionsDebriefV2IdLessonsRoute
  '/interactions/debrief-v2/$id/match-points': typeof DashboardInteractionsDebriefV2IdMatchPointsRoute
  '/deal-intelligence/project/$projectId/gap/$gapId': typeof DashboardDealIntelligenceProjectProjectIdGapGapIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/knowledge': typeof KnowledgeRoute
  '/roi-demo': typeof RoiDemoRouteWithChildren
  '/integrations': typeof AdminIntegrationsRoute
  '/deal-intelligence': typeof DashboardDealIntelligenceRoute
  '/goals': typeof DashboardGoalsRoute
  '/breaks': typeof OnboardingBreaksRoute
  '/command-center': typeof OnboardingCommandCenterRoute
  '/effectiveness': typeof OnboardingEffectivenessRoute
  '/get-started': typeof OnboardingGetStartedRoute
  '/leadership': typeof OnboardingLeadershipRoute
  '/onboarding': typeof OnboardingOnboardingRoute
  '/project': typeof OnboardingProjectRoute
  '/retrospectives': typeof OnboardingRetrospectivesRoute
  '/privacy-policy': typeof PrivacyPrivacyPolicyRoute
  '/terms-of-use': typeof PrivacyTermsOfUseRoute
  '/signin': typeof SigninSigninRoute
  '/OrganizationManagement': typeof UsersOrganizationManagementRoute
  '/admin/employee-hierarchy': typeof DashboardAdminEmployeeHierarchyRoute
  '/gap-review/final': typeof DashboardGapReviewFinalRoute
  '/interactions/DebriefWizard': typeof DashboardInteractionsDebriefWizardRoute
  '/interactions/FeedbackWizard': typeof DashboardInteractionsFeedbackWizardRoute
  '/interactions/PraiseWizard': typeof DashboardInteractionsPraiseWizardRoute
  '/roi-demo/projects/$projectId': typeof RoiDemoProjectsProjectIdRoute
  '/gap-review': typeof DashboardGapReviewIndexRoute
  '/interactions': typeof DashboardInteractionsIndexRoute
  '/one-on-one': typeof DashboardOneOnOneIndexRoute
  '/deal-intelligence/gap/$gapId': typeof DashboardDealIntelligenceGapGapIdRoute
  '/deal-intelligence/project/$projectId': typeof DashboardDealIntelligenceProjectProjectIdRoute
  '/gap-review/preview/$draftId': typeof DashboardGapReviewPreviewDraftIdRoute
  '/gap-review/run/$executionId': typeof DashboardGapReviewRunExecutionIdRoute
  '/interactions/debrief-v2/$id': typeof DashboardInteractionsDebriefV2IdRouteWithChildren
  '/interactions/debrief/$id': typeof DashboardInteractionsDebriefIdRoute
  '/interactions/feedback/$id': typeof DashboardInteractionsFeedbackIdRoute
  '/interactions/praise/$id': typeof DashboardInteractionsPraiseIdRoute
  '/one-on-one/$id/completed': typeof DashboardOneOnOneIdCompletedRoute
  '/one-on-one/$id/goals-review': typeof DashboardOneOnOneIdGoalsReviewRoute
  '/one-on-one/$id/summary': typeof DashboardOneOnOneIdSummaryRoute
  '/interactions/debrief-v2/$id/deep-dive': typeof DashboardInteractionsDebriefV2IdDeepDiveRoute
  '/interactions/debrief-v2/$id/describe': typeof DashboardInteractionsDebriefV2IdDescribeRoute
  '/interactions/debrief-v2/$id/gather': typeof DashboardInteractionsDebriefV2IdGatherRoute
  '/interactions/debrief-v2/$id/lessons': typeof DashboardInteractionsDebriefV2IdLessonsRoute
  '/interactions/debrief-v2/$id/match-points': typeof DashboardInteractionsDebriefV2IdMatchPointsRoute
  '/deal-intelligence/project/$projectId/gap/$gapId': typeof DashboardDealIntelligenceProjectProjectIdGapGapIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/_privacy': typeof PrivacyRouteRouteWithChildren
  '/knowledge': typeof KnowledgeRoute
  '/roi-demo': typeof RoiDemoRouteWithChildren
  '/_dashboard/gap-review': typeof DashboardGapReviewRouteRouteWithChildren
  '/_dashboard/interactions': typeof DashboardInteractionsRouteRouteWithChildren
  '/_admin/integrations': typeof AdminIntegrationsRoute
  '/_dashboard/deal-intelligence': typeof DashboardDealIntelligenceRoute
  '/_dashboard/goals': typeof DashboardGoalsRoute
  '/_onboarding/breaks': typeof OnboardingBreaksRoute
  '/_onboarding/command-center': typeof OnboardingCommandCenterRoute
  '/_onboarding/effectiveness': typeof OnboardingEffectivenessRoute
  '/_onboarding/get-started': typeof OnboardingGetStartedRoute
  '/_onboarding/leadership': typeof OnboardingLeadershipRoute
  '/_onboarding/onboarding': typeof OnboardingOnboardingRoute
  '/_onboarding/project': typeof OnboardingProjectRoute
  '/_onboarding/retrospectives': typeof OnboardingRetrospectivesRoute
  '/_privacy/privacy-policy': typeof PrivacyPrivacyPolicyRoute
  '/_privacy/terms-of-use': typeof PrivacyTermsOfUseRoute
  '/_signin/signin': typeof SigninSigninRoute
  '/_users/OrganizationManagement': typeof UsersOrganizationManagementRoute
  '/_dashboard/admin/employee-hierarchy': typeof DashboardAdminEmployeeHierarchyRoute
  '/_dashboard/gap-review/final': typeof DashboardGapReviewFinalRoute
  '/_dashboard/interactions/DebriefWizard': typeof DashboardInteractionsDebriefWizardRoute
  '/_dashboard/interactions/FeedbackWizard': typeof DashboardInteractionsFeedbackWizardRoute
  '/_dashboard/interactions/PraiseWizard': typeof DashboardInteractionsPraiseWizardRoute
  '/roi-demo/projects/$projectId': typeof RoiDemoProjectsProjectIdRoute
  '/_dashboard/gap-review/': typeof DashboardGapReviewIndexRoute
  '/_dashboard/interactions/': typeof DashboardInteractionsIndexRoute
  '/_dashboard/one-on-one/': typeof DashboardOneOnOneIndexRoute
  '/_dashboard/deal-intelligence_/gap/$gapId': typeof DashboardDealIntelligenceGapGapIdRoute
  '/_dashboard/deal-intelligence_/project/$projectId': typeof DashboardDealIntelligenceProjectProjectIdRoute
  '/_dashboard/gap-review/preview/$draftId': typeof DashboardGapReviewPreviewDraftIdRoute
  '/_dashboard/gap-review/run/$executionId': typeof DashboardGapReviewRunExecutionIdRoute
  '/_dashboard/interactions/debrief-v2/$id': typeof DashboardInteractionsDebriefV2IdRouteWithChildren
  '/_dashboard/interactions/debrief/$id': typeof DashboardInteractionsDebriefIdRoute
  '/_dashboard/interactions/feedback/$id': typeof DashboardInteractionsFeedbackIdRoute
  '/_dashboard/interactions/praise/$id': typeof DashboardInteractionsPraiseIdRoute
  '/_dashboard/one-on-one/$id/completed': typeof DashboardOneOnOneIdCompletedRoute
  '/_dashboard/one-on-one/$id/goals-review': typeof DashboardOneOnOneIdGoalsReviewRoute
  '/_dashboard/one-on-one/$id/summary': typeof DashboardOneOnOneIdSummaryRoute
  '/_dashboard/interactions/debrief-v2/$id/deep-dive': typeof DashboardInteractionsDebriefV2IdDeepDiveRoute
  '/_dashboard/interactions/debrief-v2/$id/describe': typeof DashboardInteractionsDebriefV2IdDescribeRoute
  '/_dashboard/interactions/debrief-v2/$id/gather': typeof DashboardInteractionsDebriefV2IdGatherRoute
  '/_dashboard/interactions/debrief-v2/$id/lessons': typeof DashboardInteractionsDebriefV2IdLessonsRoute
  '/_dashboard/interactions/debrief-v2/$id/match-points': typeof DashboardInteractionsDebriefV2IdMatchPointsRoute
  '/_dashboard/deal-intelligence_/project/$projectId_/gap/$gapId': typeof DashboardDealIntelligenceProjectProjectIdGapGapIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/knowledge'
    | '/roi-demo'
    | '/gap-review'
    | '/interactions'
    | '/integrations'
    | '/deal-intelligence'
    | '/goals'
    | '/breaks'
    | '/command-center'
    | '/effectiveness'
    | '/get-started'
    | '/leadership'
    | '/onboarding'
    | '/project'
    | '/retrospectives'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/signin'
    | '/OrganizationManagement'
    | '/admin/employee-hierarchy'
    | '/gap-review/final'
    | '/interactions/DebriefWizard'
    | '/interactions/FeedbackWizard'
    | '/interactions/PraiseWizard'
    | '/roi-demo/projects/$projectId'
    | '/gap-review/'
    | '/interactions/'
    | '/one-on-one'
    | '/deal-intelligence/gap/$gapId'
    | '/deal-intelligence/project/$projectId'
    | '/gap-review/preview/$draftId'
    | '/gap-review/run/$executionId'
    | '/interactions/debrief-v2/$id'
    | '/interactions/debrief/$id'
    | '/interactions/feedback/$id'
    | '/interactions/praise/$id'
    | '/one-on-one/$id/completed'
    | '/one-on-one/$id/goals-review'
    | '/one-on-one/$id/summary'
    | '/interactions/debrief-v2/$id/deep-dive'
    | '/interactions/debrief-v2/$id/describe'
    | '/interactions/debrief-v2/$id/gather'
    | '/interactions/debrief-v2/$id/lessons'
    | '/interactions/debrief-v2/$id/match-points'
    | '/deal-intelligence/project/$projectId/gap/$gapId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/knowledge'
    | '/roi-demo'
    | '/integrations'
    | '/deal-intelligence'
    | '/goals'
    | '/breaks'
    | '/command-center'
    | '/effectiveness'
    | '/get-started'
    | '/leadership'
    | '/onboarding'
    | '/project'
    | '/retrospectives'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/signin'
    | '/OrganizationManagement'
    | '/admin/employee-hierarchy'
    | '/gap-review/final'
    | '/interactions/DebriefWizard'
    | '/interactions/FeedbackWizard'
    | '/interactions/PraiseWizard'
    | '/roi-demo/projects/$projectId'
    | '/gap-review'
    | '/interactions'
    | '/one-on-one'
    | '/deal-intelligence/gap/$gapId'
    | '/deal-intelligence/project/$projectId'
    | '/gap-review/preview/$draftId'
    | '/gap-review/run/$executionId'
    | '/interactions/debrief-v2/$id'
    | '/interactions/debrief/$id'
    | '/interactions/feedback/$id'
    | '/interactions/praise/$id'
    | '/one-on-one/$id/completed'
    | '/one-on-one/$id/goals-review'
    | '/one-on-one/$id/summary'
    | '/interactions/debrief-v2/$id/deep-dive'
    | '/interactions/debrief-v2/$id/describe'
    | '/interactions/debrief-v2/$id/gather'
    | '/interactions/debrief-v2/$id/lessons'
    | '/interactions/debrief-v2/$id/match-points'
    | '/deal-intelligence/project/$projectId/gap/$gapId'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/_privacy'
    | '/knowledge'
    | '/roi-demo'
    | '/_dashboard/gap-review'
    | '/_dashboard/interactions'
    | '/_admin/integrations'
    | '/_dashboard/deal-intelligence'
    | '/_dashboard/goals'
    | '/_onboarding/breaks'
    | '/_onboarding/command-center'
    | '/_onboarding/effectiveness'
    | '/_onboarding/get-started'
    | '/_onboarding/leadership'
    | '/_onboarding/onboarding'
    | '/_onboarding/project'
    | '/_onboarding/retrospectives'
    | '/_privacy/privacy-policy'
    | '/_privacy/terms-of-use'
    | '/_signin/signin'
    | '/_users/OrganizationManagement'
    | '/_dashboard/admin/employee-hierarchy'
    | '/_dashboard/gap-review/final'
    | '/_dashboard/interactions/DebriefWizard'
    | '/_dashboard/interactions/FeedbackWizard'
    | '/_dashboard/interactions/PraiseWizard'
    | '/roi-demo/projects/$projectId'
    | '/_dashboard/gap-review/'
    | '/_dashboard/interactions/'
    | '/_dashboard/one-on-one/'
    | '/_dashboard/deal-intelligence_/gap/$gapId'
    | '/_dashboard/deal-intelligence_/project/$projectId'
    | '/_dashboard/gap-review/preview/$draftId'
    | '/_dashboard/gap-review/run/$executionId'
    | '/_dashboard/interactions/debrief-v2/$id'
    | '/_dashboard/interactions/debrief/$id'
    | '/_dashboard/interactions/feedback/$id'
    | '/_dashboard/interactions/praise/$id'
    | '/_dashboard/one-on-one/$id/completed'
    | '/_dashboard/one-on-one/$id/goals-review'
    | '/_dashboard/one-on-one/$id/summary'
    | '/_dashboard/interactions/debrief-v2/$id/deep-dive'
    | '/_dashboard/interactions/debrief-v2/$id/describe'
    | '/_dashboard/interactions/debrief-v2/$id/gather'
    | '/_dashboard/interactions/debrief-v2/$id/lessons'
    | '/_dashboard/interactions/debrief-v2/$id/match-points'
    | '/_dashboard/deal-intelligence_/project/$projectId_/gap/$gapId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  PrivacyRouteRoute: typeof PrivacyRouteRouteWithChildren
  KnowledgeRoute: typeof KnowledgeRoute
  RoiDemoRoute: typeof RoiDemoRouteWithChildren
  AdminIntegrationsRoute: typeof AdminIntegrationsRoute
  OnboardingBreaksRoute: typeof OnboardingBreaksRoute
  OnboardingCommandCenterRoute: typeof OnboardingCommandCenterRoute
  OnboardingEffectivenessRoute: typeof OnboardingEffectivenessRoute
  OnboardingGetStartedRoute: typeof OnboardingGetStartedRoute
  OnboardingLeadershipRoute: typeof OnboardingLeadershipRoute
  OnboardingOnboardingRoute: typeof OnboardingOnboardingRoute
  OnboardingProjectRoute: typeof OnboardingProjectRoute
  OnboardingRetrospectivesRoute: typeof OnboardingRetrospectivesRoute
  SigninSigninRoute: typeof SigninSigninRoute
  UsersOrganizationManagementRoute: typeof UsersOrganizationManagementRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/roi-demo': {
      id: '/roi-demo'
      path: '/roi-demo'
      fullPath: '/roi-demo'
      preLoaderRoute: typeof RoiDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_privacy': {
      id: '/_privacy'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivacyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_users/OrganizationManagement': {
      id: '/_users/OrganizationManagement'
      path: '/OrganizationManagement'
      fullPath: '/OrganizationManagement'
      preLoaderRoute: typeof UsersOrganizationManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_signin/signin': {
      id: '/_signin/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_privacy/terms-of-use': {
      id: '/_privacy/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof PrivacyTermsOfUseRouteImport
      parentRoute: typeof PrivacyRouteRoute
    }
    '/_privacy/privacy-policy': {
      id: '/_privacy/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPrivacyPolicyRouteImport
      parentRoute: typeof PrivacyRouteRoute
    }
    '/_onboarding/retrospectives': {
      id: '/_onboarding/retrospectives'
      path: '/retrospectives'
      fullPath: '/retrospectives'
      preLoaderRoute: typeof OnboardingRetrospectivesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding/project': {
      id: '/_onboarding/project'
      path: '/project'
      fullPath: '/project'
      preLoaderRoute: typeof OnboardingProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding/onboarding': {
      id: '/_onboarding/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding/leadership': {
      id: '/_onboarding/leadership'
      path: '/leadership'
      fullPath: '/leadership'
      preLoaderRoute: typeof OnboardingLeadershipRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding/get-started': {
      id: '/_onboarding/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof OnboardingGetStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding/effectiveness': {
      id: '/_onboarding/effectiveness'
      path: '/effectiveness'
      fullPath: '/effectiveness'
      preLoaderRoute: typeof OnboardingEffectivenessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding/command-center': {
      id: '/_onboarding/command-center'
      path: '/command-center'
      fullPath: '/command-center'
      preLoaderRoute: typeof OnboardingCommandCenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding/breaks': {
      id: '/_onboarding/breaks'
      path: '/breaks'
      fullPath: '/breaks'
      preLoaderRoute: typeof OnboardingBreaksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/goals': {
      id: '/_dashboard/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof DashboardGoalsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/deal-intelligence': {
      id: '/_dashboard/deal-intelligence'
      path: '/deal-intelligence'
      fullPath: '/deal-intelligence'
      preLoaderRoute: typeof DashboardDealIntelligenceRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_admin/integrations': {
      id: '/_admin/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AdminIntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/interactions': {
      id: '/_dashboard/interactions'
      path: '/interactions'
      fullPath: '/interactions'
      preLoaderRoute: typeof DashboardInteractionsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/gap-review': {
      id: '/_dashboard/gap-review'
      path: '/gap-review'
      fullPath: '/gap-review'
      preLoaderRoute: typeof DashboardGapReviewRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/one-on-one/': {
      id: '/_dashboard/one-on-one/'
      path: '/one-on-one'
      fullPath: '/one-on-one'
      preLoaderRoute: typeof DashboardOneOnOneIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/interactions/': {
      id: '/_dashboard/interactions/'
      path: '/'
      fullPath: '/interactions/'
      preLoaderRoute: typeof DashboardInteractionsIndexRouteImport
      parentRoute: typeof DashboardInteractionsRouteRoute
    }
    '/_dashboard/gap-review/': {
      id: '/_dashboard/gap-review/'
      path: '/'
      fullPath: '/gap-review/'
      preLoaderRoute: typeof DashboardGapReviewIndexRouteImport
      parentRoute: typeof DashboardGapReviewRouteRoute
    }
    '/roi-demo/projects/$projectId': {
      id: '/roi-demo/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/roi-demo/projects/$projectId'
      preLoaderRoute: typeof RoiDemoProjectsProjectIdRouteImport
      parentRoute: typeof RoiDemoRoute
    }
    '/_dashboard/interactions/PraiseWizard': {
      id: '/_dashboard/interactions/PraiseWizard'
      path: '/PraiseWizard'
      fullPath: '/interactions/PraiseWizard'
      preLoaderRoute: typeof DashboardInteractionsPraiseWizardRouteImport
      parentRoute: typeof DashboardInteractionsRouteRoute
    }
    '/_dashboard/interactions/FeedbackWizard': {
      id: '/_dashboard/interactions/FeedbackWizard'
      path: '/FeedbackWizard'
      fullPath: '/interactions/FeedbackWizard'
      preLoaderRoute: typeof DashboardInteractionsFeedbackWizardRouteImport
      parentRoute: typeof DashboardInteractionsRouteRoute
    }
    '/_dashboard/interactions/DebriefWizard': {
      id: '/_dashboard/interactions/DebriefWizard'
      path: '/DebriefWizard'
      fullPath: '/interactions/DebriefWizard'
      preLoaderRoute: typeof DashboardInteractionsDebriefWizardRouteImport
      parentRoute: typeof DashboardInteractionsRouteRoute
    }
    '/_dashboard/gap-review/final': {
      id: '/_dashboard/gap-review/final'
      path: '/final'
      fullPath: '/gap-review/final'
      preLoaderRoute: typeof DashboardGapReviewFinalRouteImport
      parentRoute: typeof DashboardGapReviewRouteRoute
    }
    '/_dashboard/admin/employee-hierarchy': {
      id: '/_dashboard/admin/employee-hierarchy'
      path: '/admin/employee-hierarchy'
      fullPath: '/admin/employee-hierarchy'
      preLoaderRoute: typeof DashboardAdminEmployeeHierarchyRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/one-on-one/$id/summary': {
      id: '/_dashboard/one-on-one/$id/summary'
      path: '/one-on-one/$id/summary'
      fullPath: '/one-on-one/$id/summary'
      preLoaderRoute: typeof DashboardOneOnOneIdSummaryRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/one-on-one/$id/goals-review': {
      id: '/_dashboard/one-on-one/$id/goals-review'
      path: '/one-on-one/$id/goals-review'
      fullPath: '/one-on-one/$id/goals-review'
      preLoaderRoute: typeof DashboardOneOnOneIdGoalsReviewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/one-on-one/$id/completed': {
      id: '/_dashboard/one-on-one/$id/completed'
      path: '/one-on-one/$id/completed'
      fullPath: '/one-on-one/$id/completed'
      preLoaderRoute: typeof DashboardOneOnOneIdCompletedRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/interactions/praise/$id': {
      id: '/_dashboard/interactions/praise/$id'
      path: '/praise/$id'
      fullPath: '/interactions/praise/$id'
      preLoaderRoute: typeof DashboardInteractionsPraiseIdRouteImport
      parentRoute: typeof DashboardInteractionsRouteRoute
    }
    '/_dashboard/interactions/feedback/$id': {
      id: '/_dashboard/interactions/feedback/$id'
      path: '/feedback/$id'
      fullPath: '/interactions/feedback/$id'
      preLoaderRoute: typeof DashboardInteractionsFeedbackIdRouteImport
      parentRoute: typeof DashboardInteractionsRouteRoute
    }
    '/_dashboard/interactions/debrief/$id': {
      id: '/_dashboard/interactions/debrief/$id'
      path: '/debrief/$id'
      fullPath: '/interactions/debrief/$id'
      preLoaderRoute: typeof DashboardInteractionsDebriefIdRouteImport
      parentRoute: typeof DashboardInteractionsRouteRoute
    }
    '/_dashboard/interactions/debrief-v2/$id': {
      id: '/_dashboard/interactions/debrief-v2/$id'
      path: '/debrief-v2/$id'
      fullPath: '/interactions/debrief-v2/$id'
      preLoaderRoute: typeof DashboardInteractionsDebriefV2IdRouteImport
      parentRoute: typeof DashboardInteractionsRouteRoute
    }
    '/_dashboard/gap-review/run/$executionId': {
      id: '/_dashboard/gap-review/run/$executionId'
      path: '/run/$executionId'
      fullPath: '/gap-review/run/$executionId'
      preLoaderRoute: typeof DashboardGapReviewRunExecutionIdRouteImport
      parentRoute: typeof DashboardGapReviewRouteRoute
    }
    '/_dashboard/gap-review/preview/$draftId': {
      id: '/_dashboard/gap-review/preview/$draftId'
      path: '/preview/$draftId'
      fullPath: '/gap-review/preview/$draftId'
      preLoaderRoute: typeof DashboardGapReviewPreviewDraftIdRouteImport
      parentRoute: typeof DashboardGapReviewRouteRoute
    }
    '/_dashboard/deal-intelligence_/project/$projectId': {
      id: '/_dashboard/deal-intelligence_/project/$projectId'
      path: '/deal-intelligence/project/$projectId'
      fullPath: '/deal-intelligence/project/$projectId'
      preLoaderRoute: typeof DashboardDealIntelligenceProjectProjectIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/deal-intelligence_/gap/$gapId': {
      id: '/_dashboard/deal-intelligence_/gap/$gapId'
      path: '/deal-intelligence/gap/$gapId'
      fullPath: '/deal-intelligence/gap/$gapId'
      preLoaderRoute: typeof DashboardDealIntelligenceGapGapIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/interactions/debrief-v2/$id/match-points': {
      id: '/_dashboard/interactions/debrief-v2/$id/match-points'
      path: '/match-points'
      fullPath: '/interactions/debrief-v2/$id/match-points'
      preLoaderRoute: typeof DashboardInteractionsDebriefV2IdMatchPointsRouteImport
      parentRoute: typeof DashboardInteractionsDebriefV2IdRoute
    }
    '/_dashboard/interactions/debrief-v2/$id/lessons': {
      id: '/_dashboard/interactions/debrief-v2/$id/lessons'
      path: '/lessons'
      fullPath: '/interactions/debrief-v2/$id/lessons'
      preLoaderRoute: typeof DashboardInteractionsDebriefV2IdLessonsRouteImport
      parentRoute: typeof DashboardInteractionsDebriefV2IdRoute
    }
    '/_dashboard/interactions/debrief-v2/$id/gather': {
      id: '/_dashboard/interactions/debrief-v2/$id/gather'
      path: '/gather'
      fullPath: '/interactions/debrief-v2/$id/gather'
      preLoaderRoute: typeof DashboardInteractionsDebriefV2IdGatherRouteImport
      parentRoute: typeof DashboardInteractionsDebriefV2IdRoute
    }
    '/_dashboard/interactions/debrief-v2/$id/describe': {
      id: '/_dashboard/interactions/debrief-v2/$id/describe'
      path: '/describe'
      fullPath: '/interactions/debrief-v2/$id/describe'
      preLoaderRoute: typeof DashboardInteractionsDebriefV2IdDescribeRouteImport
      parentRoute: typeof DashboardInteractionsDebriefV2IdRoute
    }
    '/_dashboard/interactions/debrief-v2/$id/deep-dive': {
      id: '/_dashboard/interactions/debrief-v2/$id/deep-dive'
      path: '/deep-dive'
      fullPath: '/interactions/debrief-v2/$id/deep-dive'
      preLoaderRoute: typeof DashboardInteractionsDebriefV2IdDeepDiveRouteImport
      parentRoute: typeof DashboardInteractionsDebriefV2IdRoute
    }
    '/_dashboard/deal-intelligence_/project/$projectId_/gap/$gapId': {
      id: '/_dashboard/deal-intelligence_/project/$projectId_/gap/$gapId'
      path: '/deal-intelligence/project/$projectId/gap/$gapId'
      fullPath: '/deal-intelligence/project/$projectId/gap/$gapId'
      preLoaderRoute: typeof DashboardDealIntelligenceProjectProjectIdGapGapIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardGapReviewRouteRouteChildren {
  DashboardGapReviewFinalRoute: typeof DashboardGapReviewFinalRoute
  DashboardGapReviewIndexRoute: typeof DashboardGapReviewIndexRoute
  DashboardGapReviewPreviewDraftIdRoute: typeof DashboardGapReviewPreviewDraftIdRoute
  DashboardGapReviewRunExecutionIdRoute: typeof DashboardGapReviewRunExecutionIdRoute
}

const DashboardGapReviewRouteRouteChildren: DashboardGapReviewRouteRouteChildren =
  {
    DashboardGapReviewFinalRoute: DashboardGapReviewFinalRoute,
    DashboardGapReviewIndexRoute: DashboardGapReviewIndexRoute,
    DashboardGapReviewPreviewDraftIdRoute:
      DashboardGapReviewPreviewDraftIdRoute,
    DashboardGapReviewRunExecutionIdRoute:
      DashboardGapReviewRunExecutionIdRoute,
  }

const DashboardGapReviewRouteRouteWithChildren =
  DashboardGapReviewRouteRoute._addFileChildren(
    DashboardGapReviewRouteRouteChildren,
  )

interface DashboardInteractionsDebriefV2IdRouteChildren {
  DashboardInteractionsDebriefV2IdDeepDiveRoute: typeof DashboardInteractionsDebriefV2IdDeepDiveRoute
  DashboardInteractionsDebriefV2IdDescribeRoute: typeof DashboardInteractionsDebriefV2IdDescribeRoute
  DashboardInteractionsDebriefV2IdGatherRoute: typeof DashboardInteractionsDebriefV2IdGatherRoute
  DashboardInteractionsDebriefV2IdLessonsRoute: typeof DashboardInteractionsDebriefV2IdLessonsRoute
  DashboardInteractionsDebriefV2IdMatchPointsRoute: typeof DashboardInteractionsDebriefV2IdMatchPointsRoute
}

const DashboardInteractionsDebriefV2IdRouteChildren: DashboardInteractionsDebriefV2IdRouteChildren =
  {
    DashboardInteractionsDebriefV2IdDeepDiveRoute:
      DashboardInteractionsDebriefV2IdDeepDiveRoute,
    DashboardInteractionsDebriefV2IdDescribeRoute:
      DashboardInteractionsDebriefV2IdDescribeRoute,
    DashboardInteractionsDebriefV2IdGatherRoute:
      DashboardInteractionsDebriefV2IdGatherRoute,
    DashboardInteractionsDebriefV2IdLessonsRoute:
      DashboardInteractionsDebriefV2IdLessonsRoute,
    DashboardInteractionsDebriefV2IdMatchPointsRoute:
      DashboardInteractionsDebriefV2IdMatchPointsRoute,
  }

const DashboardInteractionsDebriefV2IdRouteWithChildren =
  DashboardInteractionsDebriefV2IdRoute._addFileChildren(
    DashboardInteractionsDebriefV2IdRouteChildren,
  )

interface DashboardInteractionsRouteRouteChildren {
  DashboardInteractionsDebriefWizardRoute: typeof DashboardInteractionsDebriefWizardRoute
  DashboardInteractionsFeedbackWizardRoute: typeof DashboardInteractionsFeedbackWizardRoute
  DashboardInteractionsPraiseWizardRoute: typeof DashboardInteractionsPraiseWizardRoute
  DashboardInteractionsIndexRoute: typeof DashboardInteractionsIndexRoute
  DashboardInteractionsDebriefV2IdRoute: typeof DashboardInteractionsDebriefV2IdRouteWithChildren
  DashboardInteractionsDebriefIdRoute: typeof DashboardInteractionsDebriefIdRoute
  DashboardInteractionsFeedbackIdRoute: typeof DashboardInteractionsFeedbackIdRoute
  DashboardInteractionsPraiseIdRoute: typeof DashboardInteractionsPraiseIdRoute
}

const DashboardInteractionsRouteRouteChildren: DashboardInteractionsRouteRouteChildren =
  {
    DashboardInteractionsDebriefWizardRoute:
      DashboardInteractionsDebriefWizardRoute,
    DashboardInteractionsFeedbackWizardRoute:
      DashboardInteractionsFeedbackWizardRoute,
    DashboardInteractionsPraiseWizardRoute:
      DashboardInteractionsPraiseWizardRoute,
    DashboardInteractionsIndexRoute: DashboardInteractionsIndexRoute,
    DashboardInteractionsDebriefV2IdRoute:
      DashboardInteractionsDebriefV2IdRouteWithChildren,
    DashboardInteractionsDebriefIdRoute: DashboardInteractionsDebriefIdRoute,
    DashboardInteractionsFeedbackIdRoute: DashboardInteractionsFeedbackIdRoute,
    DashboardInteractionsPraiseIdRoute: DashboardInteractionsPraiseIdRoute,
  }

const DashboardInteractionsRouteRouteWithChildren =
  DashboardInteractionsRouteRoute._addFileChildren(
    DashboardInteractionsRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardGapReviewRouteRoute: typeof DashboardGapReviewRouteRouteWithChildren
  DashboardInteractionsRouteRoute: typeof DashboardInteractionsRouteRouteWithChildren
  DashboardDealIntelligenceRoute: typeof DashboardDealIntelligenceRoute
  DashboardGoalsRoute: typeof DashboardGoalsRoute
  DashboardAdminEmployeeHierarchyRoute: typeof DashboardAdminEmployeeHierarchyRoute
  DashboardOneOnOneIndexRoute: typeof DashboardOneOnOneIndexRoute
  DashboardDealIntelligenceGapGapIdRoute: typeof DashboardDealIntelligenceGapGapIdRoute
  DashboardDealIntelligenceProjectProjectIdRoute: typeof DashboardDealIntelligenceProjectProjectIdRoute
  DashboardOneOnOneIdCompletedRoute: typeof DashboardOneOnOneIdCompletedRoute
  DashboardOneOnOneIdGoalsReviewRoute: typeof DashboardOneOnOneIdGoalsReviewRoute
  DashboardOneOnOneIdSummaryRoute: typeof DashboardOneOnOneIdSummaryRoute
  DashboardDealIntelligenceProjectProjectIdGapGapIdRoute: typeof DashboardDealIntelligenceProjectProjectIdGapGapIdRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardGapReviewRouteRoute: DashboardGapReviewRouteRouteWithChildren,
  DashboardInteractionsRouteRoute: DashboardInteractionsRouteRouteWithChildren,
  DashboardDealIntelligenceRoute: DashboardDealIntelligenceRoute,
  DashboardGoalsRoute: DashboardGoalsRoute,
  DashboardAdminEmployeeHierarchyRoute: DashboardAdminEmployeeHierarchyRoute,
  DashboardOneOnOneIndexRoute: DashboardOneOnOneIndexRoute,
  DashboardDealIntelligenceGapGapIdRoute:
    DashboardDealIntelligenceGapGapIdRoute,
  DashboardDealIntelligenceProjectProjectIdRoute:
    DashboardDealIntelligenceProjectProjectIdRoute,
  DashboardOneOnOneIdCompletedRoute: DashboardOneOnOneIdCompletedRoute,
  DashboardOneOnOneIdGoalsReviewRoute: DashboardOneOnOneIdGoalsReviewRoute,
  DashboardOneOnOneIdSummaryRoute: DashboardOneOnOneIdSummaryRoute,
  DashboardDealIntelligenceProjectProjectIdGapGapIdRoute:
    DashboardDealIntelligenceProjectProjectIdGapGapIdRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface PrivacyRouteRouteChildren {
  PrivacyPrivacyPolicyRoute: typeof PrivacyPrivacyPolicyRoute
  PrivacyTermsOfUseRoute: typeof PrivacyTermsOfUseRoute
}

const PrivacyRouteRouteChildren: PrivacyRouteRouteChildren = {
  PrivacyPrivacyPolicyRoute: PrivacyPrivacyPolicyRoute,
  PrivacyTermsOfUseRoute: PrivacyTermsOfUseRoute,
}

const PrivacyRouteRouteWithChildren = PrivacyRouteRoute._addFileChildren(
  PrivacyRouteRouteChildren,
)

interface RoiDemoRouteChildren {
  RoiDemoProjectsProjectIdRoute: typeof RoiDemoProjectsProjectIdRoute
}

const RoiDemoRouteChildren: RoiDemoRouteChildren = {
  RoiDemoProjectsProjectIdRoute: RoiDemoProjectsProjectIdRoute,
}

const RoiDemoRouteWithChildren =
  RoiDemoRoute._addFileChildren(RoiDemoRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  PrivacyRouteRoute: PrivacyRouteRouteWithChildren,
  KnowledgeRoute: KnowledgeRoute,
  RoiDemoRoute: RoiDemoRouteWithChildren,
  AdminIntegrationsRoute: AdminIntegrationsRoute,
  OnboardingBreaksRoute: OnboardingBreaksRoute,
  OnboardingCommandCenterRoute: OnboardingCommandCenterRoute,
  OnboardingEffectivenessRoute: OnboardingEffectivenessRoute,
  OnboardingGetStartedRoute: OnboardingGetStartedRoute,
  OnboardingLeadershipRoute: OnboardingLeadershipRoute,
  OnboardingOnboardingRoute: OnboardingOnboardingRoute,
  OnboardingProjectRoute: OnboardingProjectRoute,
  OnboardingRetrospectivesRoute: OnboardingRetrospectivesRoute,
  SigninSigninRoute: SigninSigninRoute,
  UsersOrganizationManagementRoute: UsersOrganizationManagementRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
